import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import BattleWizard from 'components/BattleWizard/BattleWizard.jsx'
import LoadingScreen from 'components/LoadingScreen/LoadingScreen.jsx'

import { FEATURE_TYPES } from 'constants'
import { isFeatureAvailable } from 'helpers/accounts'
import { formatMessage } from 'locale'
import WINDOW_TITLES from 'window_titles'

import createUnit from 'state/actions/unit_create'
import requestUnitCreateInfo from 'state/actions/unit_create_info'

export class UnitCreateWizard extends React.Component {
    static propTypes = {
        clanIndustrialResource: PropTypes.number,
        loaded: PropTypes.bool.isRequired,
        loading: PropTypes.bool.isRequired,
        fortBattles: PropTypes.object.isRequired,
        sorties: PropTypes.object.isRequired,
        peripheryId: PropTypes.number.isRequired,
        showOldSchedule: PropTypes.bool,
        industrialResourceMultiplier: PropTypes.number.isRequired,

        createUnit: PropTypes.func.isRequired,
        requestUnitCreateInfo: PropTypes.func.isRequired,
    }

    componentWillMount() {
        document.title = formatMessage(WINDOW_TITLES.wizard_create)
        this.props.requestUnitCreateInfo()
    }

    render() {
        if (!this.props.loaded || this.props.loading) {
            return <LoadingScreen type='window' />
        }

        return (
            <BattleWizard
                clanIndustrialResource={this.props.clanIndustrialResource}
                loaded={this.props.loaded}
                loading={this.props.loading}
                fortBattles={this.props.fortBattles}
                sorties={this.props.sorties}
                peripheryId={this.props.peripheryId}
                submit={this.props.createUnit}
                showSchedule={this.props.showOldSchedule}
                industrialResourceMultiplier={this.props.industrialResourceMultiplier}
            />
        )
    }
}

export const mapStateToProps = ({ account, clan, unitCreateInfo, settings }) => {
    const { periphery_id: peripheryId } = account
    const {
        loading,
        loaded,
        fort_battles: fortBattles,
        sorties,
        expiresAt,
    } = unitCreateInfo
    const { industrialResourceMultiplier } = settings

    const clanIndustrialResource = clan ? clan.industrial_resource : null
    return {
        clanIndustrialResource,
        loading,
        loaded,
        fortBattles,
        sorties,
        peripheryId,
        expiresAt,
        showOldSchedule: !isFeatureAvailable(account, FEATURE_TYPES.SCHEDULE),
        industrialResourceMultiplier,
    }
}

export const mapDispatchToProps = {
    createUnit,
    requestUnitCreateInfo,
}

export default connect(mapStateToProps, mapDispatchToProps)(UnitCreateWizard)



// WEBPACK FOOTER //
// ./containers/UnitCreateWizard/UnitCreateWizard.jsx